<template>
  <component
    :is="data.componentType"
    v-bind="data.props"
    v-on="hasPermission ? {} : { click: rejectNavigation }"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { type Permission } from '/@/common/tiers'

interface RouteProps {
  path?: string
  params?: Record<string, string>
  query?: Record<string, string>
}

const {
  to: inputTo,
  newWindow = false,
  trackingComponent,
  permission,
} = defineProps<{
  to: string | RouteProps
  newWindow?: boolean
  trackingComponent?: string
  permission?: Permission
}>()

const emit = defineEmits<{
  block: []
}>()

const hasPermission = computed(() => {
  return !permission || permission.hasPermission.value
})

const data = computed(() => {
  if (!hasPermission.value) {
    return {
      componentType: 'span',
      props: {
        class: 'cursor-pointer',
      },
    }
  }

  let to = inputTo

  if (typeof to !== 'string') {
    if (trackingComponent) {
      if (!to.query) to.query = {}
      to.query.trackingComponent = trackingComponent
    }

    return {
      componentType: 'router-link',
      props: {
        to,
      },
    }
  }

  if (to.match(/^(http(s)?:\/\/)|(mailto:)/)) {
    if (newWindow === true) {
      return {
        componentType: 'a',
        props: {
          href: to,
          target: '_blank',
          rel: 'noopener',
        },
      }
    } else {
      return {
        componentType: 'a',
        props: {
          href: to,
        },
      }
    }
  }

  if (trackingComponent) {
    if (!to.includes('?')) to += '&'
    else to += '?'
    to += `trackingComponent=${trackingComponent}`
  }

  return {
    componentType: 'router-link',
    props: {
      to,
    },
  }
})

function rejectNavigation() {
  emit('block')
}
</script>
